export const TASK_STATUS = {
  PENDING_DEVELOPMENT: '0e1b34bc-f2c3-4778-8250-9666ee96ae59',
  IN_DEVELOPMENT: '3960193f-99e0-43c6-a6cc-4919e5d345c5',
  IN_REVIEW: '40843898-54EE-473D-A661-194F1DA0CE48',
  APPROVED: '5684969c-f3e8-49ac-9746-51e7e23f2782',
  HAND_OVER: 'vvvv969c-f3e8-49ac-9746-51e7e23f2782',
};